/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AccessTokenDto
 */
export interface AccessTokenDto {
    /**
     * User access token
     * @type {string}
     * @memberof AccessTokenDto
     */
    accessToken: string;
}

/**
 * Check if a given object implements the AccessTokenDto interface.
 */
export function instanceOfAccessTokenDto(value: object): value is AccessTokenDto {
    if (!('accessToken' in value) || value['accessToken'] === undefined) return false;
    return true;
}

export function AccessTokenDtoFromJSON(json: any): AccessTokenDto {
    return AccessTokenDtoFromJSONTyped(json, false);
}

export function AccessTokenDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccessTokenDto {
    if (json == null) {
        return json;
    }
    return {
        
        'accessToken': json['accessToken'],
    };
}

export function AccessTokenDtoToJSON(value?: AccessTokenDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'accessToken': value['accessToken'],
    };
}

